import React from 'react';
import classNames from 'classnames';

import { decodeProductName, setThumbnailSize } from 'features/pixlee/helpers';
import { PixleeWidgetEvent, UGCEvent } from 'features/pixlee/events';

import './PixleeMediaModalProductList.scss';

const PixleeMediaModalProductList = ({
	activeProduct, products, showShopNextPrevButtonToggleOn, UGCEventTypes
}) => {

	const containerClass = classNames('PixleeMediaModalProductList', {
		'PixleeMediaModalProductList--setProdDetailsHeight': !showShopNextPrevButtonToggleOn
	});
	const renderProductImage = (product) => {

		if (product.image) {

			return (
				<img
					className="PixleeMediaModalProductList__productImage"
					src={setThumbnailSize(product.image)}
					alt=""
				/>
			);

		}
		if (product.image_thumb_square) {

			return (
				<img className="PixleeMediaModalProductList__productImage" src={product.image_thumb_square} alt="" />
			);

		}
		return (
			<img
				className="PixleeMediaModalProductList__productImage"
				src="https://image.lampsplus.com/is/image/b9gt8/noimage.jpg?qlt=75&wid=80&hei=80&op_sharpen=1&resMode=sharp2&fmt=jpeg"
				alt=""
				width="80"
				height="80"
			/>
		);

	};
	const shopNowEvents = (item, product) => {

		PixleeWidgetEvent({
			type: 'action:clicked',
			data: {
				album_id: item.album_id,
				album_photo_id: item.album_photo_id,
				action_link_url: product.link
			}
		});
		if (UGCEventTypes?.shopNowAction) {

			UGCEvent({
				eventAction: UGCEventTypes.shopNowAction,
				eventLabel: product.sku
			});

		}

	};
	return (
		<div className={containerClass}>
			{products.map((product) => (
				<a
					className="PixleeMediaModalProductList__product"
					key={product.id}
					onClick={() => shopNowEvents(activeProduct, product)}
					href={product.link}
					target="_blank"
					rel="noreferrer"
				>
					{renderProductImage(product)}
					<p className="PixleeMediaModalProductList__productTitle">
						{product && product.title && decodeProductName(product.title)}
					</p>
				</a>
			))}
		</div>
	);

};

export default PixleeMediaModalProductList;
